import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { CourierForm } from "./CourierForm";
import Sidebar from "./../Sidebar/index";
import { TaxForm } from "./TaxForm";
import { Breadcrumbs } from "./../Breadcrumb/index";

export const Courier = () => {
  return (
    <>
      <Container fluid>
        <Row>
          <Sidebar />
          <Col lg={10} style={{ backgroundColor: "#f1f2f3" }}>
            <Row className="p-2">
              <Col className="slidesContent rounded shadow p-3 bg-light">
                <Breadcrumbs currentPathName="Courier Charge Details" />
                <CourierForm />
                <TaxForm />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};
